import * as moment from 'moment';
import { FormEditor } from './../../models/editors/form-editor.base.model';

export class DatePicker extends FormEditor<moment.Moment> {
    controlType = 'datepicker';

    constructor(options: {} = {}) {
        super(options);
    }
}
